import {
  ImageScaleView,
  LinearAddFilter,
  View,
  ViewOpts,
} from '@play-co/timestep-core/ui';
import TilingBackground from './TilingBackground';
import TeamCoffeeCup from './TeamCoffeeCup';
import StateObserver from 'src/StateObserver';
import gsap from 'gsap';

export default class TeamHeader extends View {
  private background!: TilingBackground;
  private branchLeft!: ImageScaleView;
  private branchRight!: ImageScaleView;

  constructor(opts: ViewOpts) {
    super(opts);
    this.addBackground();
    this.addOverlay();
    this.addDecorations();
    this.addForeground();
    this.addTitle();
  }

  private addBackground() {
    this.background = new TilingBackground({
      maskOpts: {
        superview: this,
        width: this.style.width + 4,
        height: this.style.height,
        x: -2,
      },
      tileOpts: {
        image: 'assets/ui/match2/team/team_tile_bg.png',
        columns: 4,
      },
      movementOpts: {
        direction: 'diagonal',
      },
    });
  }

  private addOverlay() {
    new ImageScaleView({
      superview: this,
      image: 'assets/ui/match2/team/team_header_overlay.png',
      width: 728,
      height: 282,
      filter: new LinearAddFilter('#FFFFFF'),
      opacity: 0.1,
    });
  }

  private addDecorations() {
    this.branchLeft = new ImageScaleView({
      superview: this.background,
      image: 'assets/ui/match2/team/team_branch.png',
      width: 256,
      height: 228,
      scaleX: -1,
      offsetX: -256,
      anchorX: 256,
      anchorY: 135,
      r: -0.44,
      x: -45,
      y: 15,
    });

    this.branchRight = new ImageScaleView({
      superview: this.background,
      image: 'assets/ui/match2/team/team_branch_long.png',
      width: 411,
      height: 130,
      anchorX: 411,
      anchorY: 25,
      x: 560,
      y: -45,
    });

    gsap.to(this.branchLeft.style, {
      duration: 1.5,
      r: -0.46,
      ease: 'quad.inOut',
      repeat: -1,
      yoyo: true,
    });
    gsap.to(this.branchRight.style, {
      duration: 1.8,
      r: 0.03,
      repeat: -1,
      ease: 'quad.inOut',
      yoyo: true,
      delay: 0.3,
    });
  }

  private addForeground() {
    const table = new ImageScaleView({
      superview: this.background,
      image: 'assets/ui/match2/team/team_header_table.png',
      width: 201,
      height: 145,
      x: -10,
      y: this.style.height - 140,
    });

    new TeamCoffeeCup({ superview: table, x: 73, y: -15, scale: 0.85 }).show(
      true,
    );
  }

  private addTitle() {
    const locale = StateObserver.getLocale();
    const width = locale === 'en' ? 495 : 462;
    const height = locale === 'en' ? 131 : 103;
    new ImageScaleView({
      superview: this,
      image: `assets/ui/match2/team/team_title_${locale}.png`,
      width,
      height,
      centerOnOrigin: true,
      x: this.style.width * 0.5,
      y: 76,
      scale: 0.88,
    });
  }

  public killAnimations() {
    gsap.killTweensOf(this.branchLeft.style);
    gsap.killTweensOf(this.branchRight.style);
  }
}
